<canvas ref="lineChart"></canvas>

<script>
import { Line } from "vue-chartjs";

export default {
  name: "LineChart",
  extends: Line,
  props: {
    title: {
      type: String,
      required: true,
    },
    dataSets: {
      type: Array,
      required: true,
    },
    labels: {
      type: Array,
      default: () => [
        "JAN",
        "FEB",
        "MAR",
        "APR",
        "MAY",
        "JUN",
        "JUL",
        "AUG",
        "SEP",
        "OCT",
        "NOV",
        "DEC",
      ],
    },
  },
  watch: {
    totalAssets: "renderLineChart",
    dataSets: "renderLineChart",
  },
  mounted() {
    this.renderLineChart();
  },
  methods: {
    renderLineChart() {
      const chartData = {
        labels: this.labels,
        datasets: this.dataSets
      };

      const chartOptions = {
        responsive: true,
        maintainAspectRatio: false,
        title: {
          display: false,
          text: this.title,
          fontSize: 18,
          fontColor: "#333",
          position: "top",
        },
        scales: {
          yAxes: [
            {
              ticks: {
                beginAtZero: true,
                suggestedMax: 50,
                callback(value) {
                  if (value >= 1000000) return value / 1000000 + "M";
                  if (value >= 1000) return value / 1000 + "K";
                  return value;
                },
              },
              gridLines: {
                drawBorder: false,
              },
            },
          ],
          xAxes: [
            {
              gridLines: {
                display: false,
              },
            },
          ],
        },
        legend: {
          position: "top",
          labels: {
            fontColor: "#333",
            usePointStyle: true,
          },
        },
      };

      this.renderChart(chartData, chartOptions);
    },
  },
};
</script>

<style scoped>
canvas {
  height: 250px !important;
}
</style>
